<template>
	<div class="row">
		<div class="col-12">
			<b-alert v-if="!has_campagne" variant="warning" show>
				{{ $t('monte.congelation.no_campagne') }}
			</b-alert>
		</div>

		<div class="col-12 form-group">
       		<label for="lot">{{ $t("monte.congelation.lot") }} *</label>
			<e-select
				v-model="lot_selected"
				id="lot"
				track-by="semencelot_id"
				label="semencelot_quantieme"
				:placeholder="$t('monte.congelation.selectionner_lot')"
				:selectedLabel="$t('global.selected_label')"
				:options="lots"
				:searchable="true"
				:show-labels="false"
				:allow-empty="true"
				:sortable="false"
			/>
		</div>
		<template v-if="lot_selected && lot_selected.semencelot_id == 0">
			<div class="col-6 form-group">
				<label for="date_lot">{{ $t("monte.congelation.date_lot") }} *</label>
				<e-datepicker id="date_lot" v-model="lot_local.semencelot_date" mode="date"></e-datepicker>
			</div>
			<div class="col-6 form-group">
				<label for="quantieme">{{ $t("monte.congelation.semencelot_quantieme") }} *</label>
				<input class="form-control" type="text" v-model="lot_local.semencelot_quantieme" id="quantieme">
			</div>
			<div class="col-6 form-group">
		        <label for="couleur" class="col-form-label">{{ $t("monte.congelation.couleur") }} *</label>
		        <e-select
		            v-model="lot_local.semencelot_couleur"
		            id="couleur"
		            track-by="semencecouleur_code"
		            :placeholder="$t('monte.stock_semence.selectionnez_couleur')"
		            :selectedLabel="$t('global.selected_label')"
		            :options="all_couleurs"
		            :searchable="true"
		            :allow-empty="false"
		            :show-labels="false"
		        >
		        	<template slot="option" slot-scope="{ option }">{{ $t('monte.couleur.'+option.semencecouleur_code) }}</template>
		           	<template slot="singleLabel" slot-scope="{ option }">{{ $t('monte.couleur.'+option.semencecouleur_code) }}</template>
		           	<template slot="noOptions">{{ $t('global.list_empty') }}</template>
				</e-select>
		    </div>
		    <div class="col-6 form-group">
                <label for="dilueur" class="col-form-label">{{ $t("monte.congelation.dilueur") }} *</label>
                <e-select
                    v-model="lot_local.semencelot_dilueur"
                    id="dilueur"
                    track-by="semencedilueur_id"
                    :placeholder="$t('monte.congelation.selectionnez_dilueur')"
                    :selectedLabel="$t('global.selected_label')"
                    :options="all_dilueurs"
                    label="semencedilueur_label"
                    :searchable="true"
                    :allow-empty="false"
                    :show-labels="false"
                />
            </div>
		</template>
		<div class="col-6 form-group">
			<label for="tiers">{{ $t("tiers.tiers") }}</label>
			<SearchTiers 
				id="tiers"
				:tiers_selected.sync="tiers"
			/>
		</div>
		<div class="col-6 form-group">
			<label for="date">{{ $t("monte.date") }} *</label>
			<e-datepicker id="date" v-model="date" mode="date"></e-datepicker>
		</div>
		<div class="col-6 form-group">
			<div>
       			<label for="stockage">{{ $t("monte.stock_semence.localisation") }} *</label>
       			<a v-if="lot_selected && lot_selected.semencelot_id !== 0" class="ml-1" href="" @click.prevent="setUpEmplacementLot(lot_selected)">
                    <font-awesome-icon :icon="['fas', 'eye']" />
                </a>
			</div>
			<e-select
				v-model="localisation_selected"
				id="stockage"
				track-by="full_name"
				label="full_name"
				:placeholder="$t('monte.stock_semence.rechercher_categorie')"
				:selectedLabel="$t('global.selected_label')"
				:options="all_localisations"
				:searchable="true"
				:show-labels="false"
				:allow-empty="true"
				:sortable="false"
			>
				<template slot="option" slot-scope="props"><span :style="`padding-left: ${25 * (props.option.indent || 0) }px;`">{{ props.option.full_name }}</span></template>
			</e-select>
		</div>
		<div class="col-6 form-group">
			<label for="qte">{{ $t("monte.congelation.qte") }} *</label>
			<input class="form-control" type="number" v-model="qte" id="qte">
		</div>
		<div class="col-6 form-group">
			<label for="commentaire">{{ $t("monte.congelation.commentaire") }}</label>
			<input class="form-control" type="text" v-model="commentaire" id="commentaire">
		</div>
		<div class="col-3 form-group">
			<label for="norme_lock">{{ $t("monte.congelation.norme_lock") }}</label>
			<b-form-checkbox v-model="norme_lock" id="norme_lock" />
		</div>
		<div class="col-3 form-group">
			<label for="control_apte">{{ $t("monte.congelation.definir_apte") }}</label>
			<b-form-checkbox v-model="control_apte" id="control_apte" />
		</div>
		<div class="col-12 text-center">
			<a class="btn btn-primary mt-3" href="#" @click.prevent="checkForm">{{ $t('global.ajouter') }} <font-awesome-icon v-if="processing" :icon="['fal', 'spinner']" pulse /><font-awesome-icon v-else :icon="['fal', 'save']" /></a>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"
	import StockSemence from "@/mixins/StockSemence.js"
	import Shutter from '@/mixins/Shutter.js'
	import ShutterCongelation from "@/mixins/shutters-manager/Congelation.js"

	export default {
		name: 'ImportPaillettes',
		mixins: [Congelation, StockSemence, Shutter, ShutterCongelation],
		props: ['horse_id', 'lot'],
		data () {
			return {
				tiers: null,
				date: new Date(),
				localisation_selected: null,
				all_localisations: [],
				qte: 1,
				commentaire: '',
				norme_lock: true,
				control_apte: false,
				lots: [],
				lot_selected: null,
				lot_local: {
					semencelot_date: new Date(),
					semencelot_quantieme: '',
					semencelot_couleur: null,
					semencelot_dilueur: null
				},
				processing: false,
				has_campagne: true,
				all_couleurs: [],
				all_dilueurs: []
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.lots = await this.getLotsByStallion(this.horse_id)
				this.lots.unshift({
					semencelot_id: 0,
					semencelot_quantieme: this.getTrad('monte.congelation.ajouter_lot')
				})
				if(this.lot) {
					this.lot_selected = this.lots.find(lot => lot.semencelot_id == this.lot.semencelot_id)
				}
				const all_localisations = await this.getLocalisationSemenceFullName()
				this.all_localisations = all_localisations.filter(loc => !loc.semencelocalisation_transport && loc.semencelocalisation_is_floor && !loc.semencelocalisation_command)
				this.all_couleurs = await this.getAllSemenceCouleur()
				this.all_dilueurs = await this.getAllDilueurs()
			},

			async checkForm() {
				let lot_id = this.lot_selected.semencelot_id
				if(!this.lot_selected || !this.date || !this.qte || !this.localisation_selected || (lot_id == 0 && (!this.lot_local.semencelot_couleur || !this.lot_local.semencelot_dilueur))) {
					return false
				}
				this.processing = true
				if(lot_id == 0) {
					this.lot_local.semencelot_qte = this.qte
					this.lot_local.semencelot_couleur = this.lot_local.semencelot_couleur.semencecouleur_id
					this.lot_local.semencelot_dilueur = this.lot_local.semencelot_dilueur.semencedilueur_id
					const lot = await this.createLotByStallion(this.horse_id, this.lot_local)
					lot_id = lot.semencelot_id
				}
				const tiers_id = this.tiers ? this.tiers.tiers_id : null
				await this.addEmplacement(lot_id, this.qte, this.commentaire, null, this.localisation_selected.semencelocalisation_id, this.date, this.norme_lock, tiers_id, this.control_apte)
				this.processing = false
				this.ok()
				this.shutterPanel().close('import-paillettes')
			}
		},

		watch: {
			'lot.semencelot_date'(val) {
				if(val) {
					this.checkCampagne(this.horse_id, val.toDateInputValue()).then(res => {
						this.has_campagne = res
					})
				}
			},
			'lot_selected.semencelot_id'(val) {
				if(val == 0) {
					this.checkCampagne(this.horse_id, this.lot_local.semencelot_date.toDateInputValue()).then(res => {
						this.has_campagne = res
					})
				}
				else {
					this.has_campagne = true
				}
			}
		},

		components: {
			SearchTiers : () => import('@/components/Contract/SearchTiers')
		}
	}

</script>